import { GalleryService } from './../../../services/galley/gallery.service';
import { FileService } from 'src/app/shared/services/file/file.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GalleryModel } from 'src/app/shared/model/gallery.model';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';

@Component({
  selector: 'app-campaign-gallery',
  templateUrl: './campaign-gallery.component.html',
  styleUrl: './campaign-gallery.component.scss',
})
export class CampaignGalleryComponent implements OnInit {
  @Output() getUpdatedGallery = new EventEmitter<void>();

  public actionTitle: string = '';

  public ngoId: string;
  public projectId: string;

  private companyId: string;
  private title: string;

  private campaignId: string;
  @Input() galleryId: string;
  @Output() galleryItems = new EventEmitter<number>();

  public isGalleryPresent: boolean = true;
  private galleryModel: GalleryModel = new GalleryModel();
  public gallery: any[] = [];
  private inputImageList: any;
  public selectedImages: boolean[] = [];
  private selectedImagesId: string[] = [];

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fileService: FileService,
    private readonly galleryService: GalleryService,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const encryptedString = params['data'];
      const decryptedParams =
        this.localStorageService.decryptObjectUrl(encryptedString);

      if (decryptedParams) {
        this.ngoId = decryptedParams?.ngo_id;
        this.projectId = decryptedParams?.project_id;

        this.companyId = decryptedParams?.company_id;
        this.campaignId = decryptedParams?.campaign_id || decryptedParams?.id;
        this.title = decryptedParams?.title;

        this.getCampaignGalleryItemCount();
      }
    });

    if (this.galleryId) {
      this.getGalleryImages();
    }
  }

  private getCampaignGalleryItemCount(): void {
    this.galleryService
      .getGalleryItemCount(this.campaignId)
      .subscribe((result: any) => {
        if (result) {
          this.galleryId = result.id;
          this.getGalleryImages();
        } else {
          this.isGalleryPresent = false;
        }
      });
  }

  public async createGallery() {
    const isCorporate = this.router.url.includes('/corporate/');

    const response = await this.confirmAction(
      'You want to create a new gallery?',
      'Create'
    );

    if (response?.isConfirmed) {
      if (this.ngoId) {
        this.galleryModel.ngo_id = this.ngoId;
        this.galleryModel.project_id = this.projectId;
      } else if (this.companyId) {
        this.galleryModel.ngo_id = this.companyId;
      }
      this.galleryModel.title = this.title;
      this.galleryModel.campaign_id = this.campaignId;

      this.galleryService
        .createGallery(this.galleryModel, isCorporate)
        .subscribe((result: any) => {
          this.isGalleryPresent = true;
          this.getCampaignGalleryItemCount();
        });
    }
  }

  private getGalleryImages(): void {
    this.galleryService.getGallery(this.galleryId).subscribe((res: any) => {
      this.gallery = res;
      this.galleryItems.emit(this.gallery?.length);
      this.getUpdatedGallery.emit();
      this.selectedImages = Array(this.gallery?.length).fill(false);
      this.selectedImagesId = [];
    });
  }

  public onFileChange(e: any): void {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files: FileList = input.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Check if it's a video and exceeds 2MB
        if (file.type.startsWith('video/') && file.size > 5 * 1024 * 1024) {
          this.utilitiesService.showSwalWithToast(
            'Warning',
            'Video size should be less than 5MB',
            'warning',
            true,
            10000,
            false,
            true
          );
          continue; // Skip processing this file
        } else {
          this.inputImageList = input.files;
          this.addGalleryImages();
        }

        // Process the valid file (image or acceptable video)
        console.log('File accepted:', file.name);
      }
    }
  }

  public async addGalleryImages() {
    const response = await this.confirmAction(
      `You want to add the assets?`,
      'Yes'
    );

    if (response?.isConfirmed) {
      this.fileService
        .uploadGalleryFiles(this.inputImageList, this.galleryId)
        .subscribe((res: any) => {
          this.getGalleryImages();
        });
    } else {
      this.selectedImages = Array(this.gallery?.length).fill(false);
      this.selectedImagesId = [];
    }
  }

  public changeActionTitle(e: any): void {
    this.actionTitle = e.itemData.text;
  }

  public async action() {
    this.selectedImagesId = this.gallery
      .filter((_, index) => this.selectedImages[index])
      .map((obj) => obj.file_id);

    if (this.selectedImagesId.length > 1 && this.actionTitle === 'Share') {
      this.utilitiesService.showSwal(
        'error',
        'Can not share multiple files at a time.',
        'Please select only one file.'
      );
      return;
    }
    const response = await this.confirmAction(
      `You want to ${this.actionTitle} the assets?`,
      'Yes'
    );

    if (response?.isConfirmed) {
      if (this.selectedImagesId?.length > 0) {
        this[this.actionTitle.toLowerCase() + 'Images']();
      }
    }
  }

  private deleteImages(): void {
    this.fileService
      .deleteFileMultiple(this.selectedImagesId)
      .subscribe((res: any) => {
        this.getGalleryImages();
      });
  }

  private shareImages(): void {
    const imageUrl = this.gallery
      .filter((_, index) => this.selectedImages[index])
      .map((obj) => obj.url);

    console.log('shareImages');
    const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      imageUrl[0]
    )}`;
    window.open(fbShareUrl, '_blank');
  }

  private downloadImages(): void {
    console.log('downloadImages');
  }

  public triggerFileInput(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  public extractedText(text: string): string {
    return text.split('/')[0].toUpperCase();
  }

  private async confirmAction(message: string, confirmButtonText: string) {
    return await this.utilitiesService.showSwalAndReturn({
      type: 'warning',
      title: 'Are you sure?',
      message: message,
      confirmButtonText: confirmButtonText,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
    });
  }
}
